import {Component} from 'react';
import h from 'react-hyperscript';
import './BasicInfo.scss';
import {h3, p} from 'Components/Typography/Typography';
import {checkFieldValue} from 'Src/utils/utils';
import CardWithSidebar from 'Components/Cards/CardWithSidebar';
import Button from 'Components/Buttons/Buttons';
import PrefilledInput from 'Components/Form/PrefilledInput';
import SelectGroup from 'Components/Form/Select';
import SurveyHeader from 'Pages/TransformationSurvey/SurveyHeader/SurveyHeader';

class BasicInfo extends Component {
  constructor(props) {
    super(props);
    const profile = this.props.googleUser.getBasicProfile();

    this._isMounted = false;
    this.state = {
      mountedClass: 'fade-out',
      elementComplete: {
        total: props.content.questions.length,
        answered: 0,
        remaining: 0,
        percentage: 0,
      },
      surveyValues: {
        name: profile.getGivenName(),
        title: '',
        email: profile.getEmail(),
        districtName: this.props.districtName,
      },
    };

    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.setMountedClass();

    this.checkElementProgress();
    if (this.props.fieldValues.basicInfoValues &&
      this.props.fieldValues.basicInfoValues.surveyValues) {
      this.setSurveyValues();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setMountedClass();
  }

  setSurveyValues() {
    this.setState({
      surveyValues: this.props.fieldValues.basicInfoValues.surveyValues,
    }, () => {
      this.checkElementProgress();
    });
  }

  getMessage() {
    const {state, props} = this;
    return (
      state &&
      state.elementComplete &&
      state.elementComplete.percentage < 1
    ) ? props.content.buttons.continueMessage.replace(
        'XX%', state.elementComplete.remaining
    ) : '';
  }
  hideEmail(email) {
    let hiddenEmail = '';
    for (let i = 0; i < email.length; i++) {
      if (i > 2 && i< email.indexOf('@')) {
        hiddenEmail += '*';
      } else {
        hiddenEmail += email[i];
      }
    }
    return hiddenEmail;
  }

  setMountedClass() {
    let value;
    if (this._isMounted) {
      value = 'fade-in';
    } else {
      value = 'fade-out';
    }
    this.setState({
      mountedClass: value,
    });
  }

  checkElementProgress(shouldSave) {
    const numTotal = this.state.elementComplete.total;
    let numAnswered = 0;
    for (const key in this.state.surveyValues) {
      if (this.state.surveyValues.hasOwnProperty(key)) {
        const val = this.state.surveyValues[key];
        if (val && val.length !== 0) {
          numAnswered++;
        }
      }
    }
    this.setState({
      elementComplete: {
        total: numTotal,
        answered: numAnswered,
        remaining: numTotal - numAnswered,
        percentage: numAnswered / numTotal,
      },
    }, () => {
      if (shouldSave) {
        this.props.saveValues(this.state, 'basicInfoValues', true);
      }
    });
  }

  handleSelectChange(e) {
    const value = e.currentTarget.getAttribute('data-value');
    this.setState((state, props) => ({
      surveyValues: {
        ...this.state.surveyValues,
        title: value,
      },
    }), () => {
      this.checkElementProgress(true);
    });
  }

  render() {
    const {elementComplete} = this.state;
    return (
      h('div', {
        className: 'container survey-element__container',
        id: this.props.id,
      }, [
        h(SurveyHeader, {
          key: 'survey-element-header__key',
          districtName: this.props.districtName,
          totalPercentComplete: this.props.totalPercentComplete,
        }, null),

        h(CardWithSidebar, {
          key: 'basic-info-card__key',
          className: this.props.className,
          activeStep: this.props.activeStep,
          goToStep: this.props.goToStep,
          fieldValues: this.props.fieldValues,
          elementComplete: this.state.elementComplete,
          showSectionProgress: this.props.showSectionProgress,
          sidebarItems: this.props.sidebarItems,
          completedSteps: this.props.completedSteps,
        }, [
          h('div', {
            className:
              `card-main__content basic-info ${this.state.mountedClass}`,
          }, [
            h(h3, {
              key: 'card-element-title__key',
              className: 'card-element__title padding-top--sm',
            }, this.props.content.title),

            h('div', {
              className: 'two-col',
            }, this.props.content.questions.map((inputGroup, i) => {
              let inputGroupElement;
              switch (inputGroup.fieldType) {
                case 'prefilled':
                  let preFilledVal;
                  if (inputGroup.id === 'email') {
                    preFilledVal =
                      this.hideEmail(this.state.surveyValues.email);
                  } else {
                    preFilledVal = checkFieldValue(inputGroup.id,
                        this.state.surveyValues);
                  }
                  inputGroupElement = h(PrefilledInput, {
                    key: inputGroup.id,
                    id: inputGroup.id,
                    logoutClick: this.props.logoutClick,
                    label: inputGroup.title,
                    defaultValue: preFilledVal,
                  }, null);
                  break;
                default:
                  inputGroupElement = h(SelectGroup, {
                    key: inputGroup.id,
                    id: inputGroup.id,
                    name: inputGroup.id,
                    label: inputGroup.title,
                    type: inputGroup.fieldType,
                    options: inputGroup.options,
                    onChange: this.handleSelectChange,
                    value: this.state.surveyValues.title,
                  }, null);
                  break;
              }
              return inputGroupElement;
            })),
            h(Button, {
              key: 'survey-button-icon',
              className: `${elementComplete && elementComplete.percentage < 1 ?
                 'button--centered button--disabled' :
                 'button--centered button--no-max-width'}`,
              to: '#',
              type: 'flat',
              onClick: (e) => {
                e.preventDefault();
                this.props.saveAndContinue(
                    this.state, 'basicInfoValues', false
                );
              },
            }, [
              h('span', {
                className: 'material-icons',
              }, 'arrow_downward'),
              h('span', {
                className: 'button__text',
              }, this.props.content.buttons.continue),
            ]),

            h(p, {
              key: 'basic-info-survey-button-message',
              className:
                `text--grey text--center padding-top--micro text-center
                footnote${
                  (
                    this.state.elementComplete &&
                    this.state.elementComplete.percentage < 1
                  ) ? '' : 'hide--mobile hide--desktop'
      }`,
            }, this.getMessage()),
          ]),
        ]),
      ])
    );
  }
}


export default BasicInfo;
